function setCustomMaxWidth() {
  if (isAutoMargin()) {
    // gets first row in element on page that hasn't a custom max width and get its style
    const element = document.querySelector('.element:not(.custom-max) .nzr--row');
    if (element) {
      const elementStyle = element.currentStyle || window.getComputedStyle(element);

      // loop through custom-max elements
      document.querySelectorAll('.custom-max').forEach(item => {
        item.style.maxWidth = `calc(100% - (6.25rem + ${elementStyle.marginLeft} + 1rem))`;
      });
    }
  } else {
    document.querySelectorAll('.custom-max').forEach(item => {
      item.style.maxWidth = '';
    });
  }
}

function isAutoMargin() {
  const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  if (width > 1640 && width < 1840) {
    return true;
  }
  return false;
}

const watchCustomMax = () => {
  // on resize
  window.addEventListener('resize', event => {
    setCustomMaxWidth();
  });

  // on load
  setCustomMaxWidth();
};

export default watchCustomMax;
